/**
 * Scout v0 — run status badge (P17).
 *
 * Status is always shown as text inside the badge (never state-by-color-alone).
 * completed → green (primary), running → violet (secondary), failed/pending →
 * amber (warning).
 */

import type { RunStatus } from '@/types/scout';

const BADGE_CLASS: Record<RunStatus, string> = {
  completed: 'badge-primary',
  running: 'badge-secondary',
  failed: 'badge-warning',
  pending: 'badge-warning',
};

export function RunStatusBadge({ status }: { status: RunStatus }) {
  return <span className={`badge ${BADGE_CLASS[status] ?? 'badge-secondary'}`}>{status}</span>;
}
